import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import { NavItem, NavDropdown } from 'react-bootstrap'

import { isFromLCRP } from '../../../shared/lib/util'
import closeIcon from 'Assets/x-icon-dark-gray.svg'

import style from './style.css'

const previewChoices = []
previewChoices.push({ value: '0', label: 'Beginning of Activity' })
previewChoices.push({ value: '1', label: 'Readings Done' })
previewChoices.push({ value: '2', label: 'Quiz Completed' })
previewChoices.push({ value: '3', label: 'Quiz Retaken' })
previewChoices.push({ value: '-1', label: 'Exit Student Preview' })

let i = 2

export default class PreviewBar extends React.Component {
  changePreview (value) {
    console.log('changing preview to ' + value)
    this.props.onPause()
    if (isFromLCRP()) {
      this.props.onHideQuiz()
    }
    this.props.onSelect(value)
  }

  endPreview () {
    this.props.exitClick ? this.props.exitClick() : this.props.onSelect('-1')
  }

  renderDropdown () {
    return (
      <NavDropdown eventKey={2} title="Jump To:" id="basic-nav-dropdown" className={style.previewDropDown}>
        {
          _.map(previewChoices, (choice) => {
            i = i + 0.1
            return (
              <NavItem
                key={i}
                onClick={() => this.changePreview(choice.value)}
                className={style.previewLink}
              >
                {choice.label}
              </NavItem>
            )
          })
        }
      </NavDropdown>)
  }

  render () {
    const previewText = this.props.browser.lessThan.medium ? 'Student Preview' : 'Previewing as a Student'
    const closeText = 'End Preview'
    const closeIconHtml = '<input type="image" alt="' + closeText + ' Button" ' +
    ' src="' + closeIcon + '" class="' + style.svgIcon + '" />'
    const closeHtml = this.props.browser.lessThan.medium
      ? closeIconHtml
      : '<span tabIndex="0">' + closeText + '</span>'
    return (
      <div className={style.previewContainer}>
        <div className={style.leftNav}>
          <ul className={classnames(style.listInline, style.leftNavItems)}>
            <li>{previewText}</li>
            <li>{isFromLCRP() ? this.renderDropdown() : null}</li>
          </ul>
        </div>
        <div className={style.rightNav}>
          <ul className={classnames(style.listInline, style.rightNavItems)}>
            <li onClick={this.endPreview.bind(this)} dangerouslySetInnerHTML={{ __html: closeHtml }} />
          </ul>
        </div>
      </div>
    )
  }
}

PreviewBar.propTypes = {
  exitClick: PropTypes.func,
  onSelect: PropTypes.func,
  onPause: PropTypes.func,
  onHideQuiz: PropTypes.func,
  browser: PropTypes.object
}
